import { render } from "./IndexLogin.vue?vue&type=template&id=6b6dc7c4&scoped=true"
import script from "./IndexLogin.vue?vue&type=script&lang=js"
export * from "./IndexLogin.vue?vue&type=script&lang=js"

import "./IndexLogin.vue?vue&type=style&index=0&id=6b6dc7c4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6dc7c4"]])

export default __exports__